module.exports = __webpack_public_path__ + "static/media/logo-1.d07cdd41.svg";